import React from 'react';
import { Handle, Position } from 'reactflow';
import useSyncNodeInternals from '../Components/useSyncNodeInternals';

import { FaArrowRightArrowLeft } from 'react-icons/fa6';
import NodeCardShell from '../Components/NodeCardShell';
import { describeConditionsSentence } from '../Components/nodeSummary';
import NodeOutputRow, { NodeOutputGroup } from '../Components/NodeOutputRow';

const CONDITIONS_NODE_COLOR = '#E5253D';

const Conditions = ({ data, isConnectable, id, selected }) => {
  useSyncNodeInternals(id, `${data.saved}~${data.first}`);

  return (
    <NodeCardShell
      icon={FaArrowRightArrowLeft}
      color={CONDITIONS_NODE_COLOR}
      typeName="Condiciones"
      title={data.title ?? 'Condiciones'}
      summary={describeConditionsSentence(data.conditions)}
      trigger={data.user_response}
      error={data?.error}
      selected={selected}
      first={data.first}
      handles={
        !data.first && data.saved && (
          <Handle
            type="target"
            position={Position.Top}
            isConnectable={isConnectable}
            id={`target-${id}`}
            style={{ backgroundColor: CONDITIONS_NODE_COLOR }}
          />
        )
      }
    >
      {data.saved && (
        <NodeOutputGroup>
          <NodeOutputRow
            label={data.succes}
            color="#4ADE80"
            handleId={`source-conditions-success`}
            isConnectable={isConnectable}
          />
          <NodeOutputRow
            label={data.failed}
            color="#F87171"
            handleId={`source-conditions-failed`}
            isConnectable={isConnectable}
          />
        </NodeOutputGroup>
      )}
    </NodeCardShell>
  );
};

export default React.memo(Conditions);
